export enum MetaTags {
  DESCRIPTION_TAG = 'DESCRIPTION_TAG',
  IMAGE_TAG = 'IMAGE_TAG',
  TITLE_TAG = 'TITLE_TAG',
  URL_TAG = 'URL_TAG'
}
